import { render, staticRenderFns } from "./Tfprocessing.vue?vue&type=template&id=292d2505&"
import script from "./Tfprocessing.vue?vue&type=script&lang=js&"
export * from "./Tfprocessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports